<div class="my-reservations-page">
  <div class="page-header">
    <h3 class="page-title">{{ 'Upcoming Bookings' | translate }}</h3>
  </div>

  @if (!only_recurring) {
    <div class="reservation-section">
      <h4 class="section-title">{{ 'My Bookings' | translate }}</h4>
      <ng-container *ngrxLet="reservationsMadeFromUser$ as reservations">
        <div class="res-list">
          @if (reservations && reservations.length > 0) {
            @for (r of reservations; track r.id) {
              <div class="res-card-wrapper">
                <div class="res-card" (click)="toggleExpanded(r.id, r)">
                  <div class="res-main-info">
                    <div class="res-date-time">
                      <span class="res-date">{{ getDateName(r.startDateAndTime) }} {{ translationService.getTranslatedDateAndTime(r.startDateAndTime) }}</span>
                      <span class="res-time">{{ getTime(r.startDateAndTime, r.endDateAndTime) }}</span>
                    </div>
                    @if (courtName) {
                      <div class="res-court">{{ r.courtName | translate }}</div>
                    }
                  </div>
                  
                  <div class="res-actions" (click)="$event.stopPropagation()">
                    @if (isAllowedToEdit(r) && users_involved) {
                      <button mat-icon-button (click)="editReservation(r)" class="edit-btn">
                        <mat-icon>edit</mat-icon>
                      </button>
                    }
                    @if (isAllowedToCancel(r)) {
                      <button mat-icon-button (click)="cancelReservation(r)" class="cancel-btn">
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                    
                  </div>
                </div>
                @if (isExpanded[r.id]) {
                  <div class="expanded-details">
                    <label>{{ 'Players' | translate }}</label>
                    <div class="players-list">
                      @for (name of userNames[r.id]; track name) {
                        <span class="player-tag">{{ name }}</span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          } @else {
            <div class="empty-state">
              <p>{{ 'No reservations found.' | translate }}</p>
            </div>
          }
        </div>
      </ng-container>
    </div>

    <div class="reservation-section">
      <h4 class="section-title">{{ 'Bookings You Were Added To' | translate }}</h4>
    </div>
  }

  <ng-container *ngrxLet="reservationsUserIsIncluded$ as reservations">
    <div class="res-list">
      @if (reservations && reservations.length > 0) {
        @for (r of reservations; track r.id) {
          <div class="res-card-wrapper">
            <div class="res-card" (click)="toggleExpanded(r.id, r)">
              <div class="res-main-info">
                <div class="res-date-time">
                  <span class="res-date">{{ getDateName(r.startDateAndTime) }} {{ translationService.getTranslatedDateAndTime(r.startDateAndTime) }}</span>
                  <span class="res-time">{{ getTime(r.startDateAndTime, r.endDateAndTime) }}</span>
                </div>

                @if (r.bookedByAdminReason) {
                  <div class="res-admin-reason">{{ r.bookedByAdminReason | translate }}</div>
                }

                @if (!(combined || single_court)) {
                  <div class="res-sub-info">{{ r.value }}</div>
                }

                @if (courtName) {
                  <div class="res-court">{{ r.courtName | translate }}</div>
                }
              </div>

              <div class="res-actions" (click)="$event.stopPropagation()">
                @if (r.bookedByAdminReason && isAllowedToCancel(r)) {
                  @if (r.bookedByAdminReason === 'Auto Matchmaking') {
                    <button mat-icon-button (click)="cancelMatchmakingReservation(r)" class="cancel-btn">
                      <mat-icon>close</mat-icon>
                    </button>
                  } @else {
                    <button mat-icon-button (click)="leaveRucurring(r.id)" class="cancel-btn">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                }
              </div>
            </div>
            @if (isExpanded[r.id] && (show_recurring_participants || !r.bookedByAdminReason || r.bookedByAdminReason === 'Auto Matchmaking')) {
              <div class="expanded-details">
                <label>{{ 'Players' | translate }}</label>
                <div class="players-list">
                  @for (name of userNames[r.id]; track name) {
                    <span class="player-tag">{{ name }}</span>
                  }
                </div>
              </div>
            }
          </div>
        }
      } @else {
        <div class="empty-state">
          <p>{{ 'No reservations found.' | translate }}</p>
        </div>
      }
    </div>
  </ng-container>

  @if (joinTheQueueFeature) {
    <ng-container *ngrxLet="pendingReservations$ as pendingReservations">
      <div class="reservation-section">
        <h4 class="section-title">{{ 'Pending bookings' | translate }}</h4>
        <div class="res-list">
          @if (pendingReservations && pendingReservations.length > 0) {
            @for (r of pendingReservations; track r.id) {
              <div class="res-card pending-card">
                <div class="res-main-info">
                  <div class="res-date-time">
                    <span class="res-date">{{ getDateName(r.start_time) }} {{ translationService.getTranslatedDateAndTime(r.start_time) }}</span>
                  </div>
                  @if (!(only_recurring && single_court)) {
                    <div class="res-court">{{ r.court_name | translate }}</div>
                  }
                  <div class="res-admin-reason">{{ r.booked_by_admin_reason | translate }}</div>
                </div>
                <div class="res-actions">
                  <button mat-icon-button (click)="removeFromQueue(r.reservation_id)" class="cancel-btn">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            }
          } @else {
            <div class="empty-state">
              <p>{{ 'No pending bookings found.' | translate }}</p>
            </div>
          }
        </div>
      </div>
    </ng-container>
  }

  <div class="history-section-wrapper">
    <app-user-reservation-history></app-user-reservation-history>
  </div>
</div>
